import React, { useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Maybe from 'react-maybe';
import { Typo } from '.';

const Paragraph = ({ children, limit }) => {
    const shouldTrim = useMemo(() => children.length > limit, [children]);
    const [opened, setOpened] = useState(false);
    const handleClick = useCallback(() => {
        setOpened(!opened);
    }, [opened]);
    const trimmed = useMemo(() => `${children.toString().substr(0, limit).replace(/\.([^.]*)$/, '$1')}${'...&nbsp;'}`, children);
    const childrenWithSpace = `${children}${' '}`;
    return (
        <Maybe
            of={shouldTrim}
            either={(
                <Maybe
                    of={opened}
                    either={(
                        <>
                            <Typo.Body className="body-typo" dangerouslySetInnerHTML={{ __html: childrenWithSpace }} />
                            <Typo.Link onClick={handleClick}>Ukryj</Typo.Link>
                        </>
                    )}
                    orElse={(
                        <>
                            <Typo.Body className="body-typo" dangerouslySetInnerHTML={{ __html: trimmed }} />
                            <Typo.Link onClick={handleClick}>Zobacz więcej</Typo.Link>
                        </>
                    )}
                />
            )}
            orElse={(
                <Typo.Body dangerouslySetInnerHTML={{ __html: children }} />
            )}
        />
    );
};

Paragraph.propTypes = {
    children: PropTypes.string.isRequired,
    limit: PropTypes.number
};
Paragraph.defaultProps = {
    limit: 500
};

export default Paragraph;
